<mgl-map
  [style]="mapStyle"
  [zoom]="[currentZoom]"
  [center]="mapCenterConfig"
  (mapLoad)="onMapLoad($event)"
  [renderWorldCopies]="false"
>
  <mgl-geojson-source
    id="edges"
    [data]="edgeFeatures"
  ></mgl-geojson-source>
  <mgl-geojson-source
    id="nodes"
    [data]="nodeFeatures"
  ></mgl-geojson-source>
  <mgl-geojson-source
    id="clusters"
    [data]="clusterFeatures"
  ></mgl-geojson-source>
  <mgl-geojson-source
    id="boundaries"
    [data]="boundaryFeatures"
  ></mgl-geojson-source>

  <!-- CLUSTERS -->
  <mgl-layer
    id="clusters"
    source="clusters"
    type="fill"
    [paint]="{
      'fill-color': ['get', 'fill'],
      'fill-opacity': 0.7,
      'fill-outline-color': ['get', 'stroke']
    }">
  </mgl-layer>

  <!-- BOUNDARIES -->
  <mgl-layer
    id="boundaries"
    source="boundaries"
    type="line"
    minZoom="2"
    [paint]="{
      'line-color': ['get', 'stroke'],
      'line-width': 0.5,
      'line-opacity': 0.8
    }"
  ></mgl-layer>

  <!-- EDGES -->
  <mgl-layer
    id="edges"
    source="edges"
    type="line"
    [paint]="{
      'line-color': ['case',
          ['boolean', ['feature-state', 'hover'], false], 'red',
          ['get', 'color', edgeFormula]
      ],
      'line-width': ['get', 'width', edgeFormula],
      'line-opacity': ['get', 'opacity', edgeFormula]
    }"
    [filter]="['>=', currentZoom, ['get', 'zoom', edgeFormula]]"
    (layerClick)="edgeClicked($event)">
  </mgl-layer>

  <!-- EDGES BORDER -->
  <mgl-layer
    id="edges_border"
    source="edges"
    type="line"
    [paint]="{
      'line-color': ['get', 'borderColor', edgeFormula],
      'line-width': ['get', 'borderWidth', edgeFormula],
      'line-opacity': ['get', 'borderOpacity', edgeFormula],
      'line-gap-width': ['get', 'width', edgeFormula]
    }"
    [filter]="['>=', currentZoom, ['get', 'zoom', edgeFormula]]">
  </mgl-layer>

  <!-- NODES -->
  <mgl-layer
    id="nodes"
    source="nodes"
    type="circle"
    [paint]="{
      'circle-color': ['case',
          ['boolean', ['feature-state', 'hover'], false], 'red',
          'black'
      ],
      'circle-radius': 3
    }"
    [filter]="['>=', currentZoom, currentEdgeFormula]"
    (layerClick)="nodeClicked($event)">
  </mgl-layer>

  <!-- NODE LABELS -->
  <mgl-layer
    id="node_labels"
    source="nodes"
    type="symbol"
    [layout]="nodeLabelsLayout"
    [filter]="['>=', currentZoom, ['get', 'zoom', currentNodeFormula]]">
  </mgl-layer>
</mgl-map>